// Utilitaires partagés par les graphiques (StockChart, CapitalChart) pour calculer des
// graduations d'axe Y "rondes" (1, 2, 5, 10, 20, 50, 100…) réparties sur une plage de valeurs.

// Pas "rond" qui découpe `range` en ~targetCount paliers
export function niceStep(range, targetCount) {
  if (!isFinite(range) || range <= 0) return 1;
  const roughStep = range / Math.max(1, targetCount - 1);
  const exponent = Math.floor(Math.log10(roughStep));
  const fraction = roughStep / Math.pow(10, exponent);
  const niceFraction = fraction < 1.5 ? 1 : fraction < 3 ? 2 : fraction < 7 ? 5 : 10;
  return niceFraction * Math.pow(10, exponent);
}

// Valeurs de paliers arrondis, espacés régulièrement, couvrant [min, max]
export function niceTicks(min, max, targetCount) {
  if (min === max) { min -= 1; max += 1; }
  const step = niceStep(max - min, targetCount);
  const niceMin = Math.floor(min / step) * step;
  const niceMax = Math.ceil(max / step) * step;
  const ticks = [];
  for (let v = niceMin; v <= niceMax + step / 2; v += step) {
    ticks.push(Math.round(v / step) * step);
  }
  return { ticks, step };
}
